export default  {
  title: {
    en: 'Review your scent',
  },
  text: {
    en: 'Tell us what you thought of this fragrance!',
  },
  submitTitle: {
    en: 'Submit review',
  },
  saveTitle: {
    en: 'Save review',
  },
}
